import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/reports',
    name: 'Reports',
    component: () => import('../views/Reports.vue')
  },
  {
    path: '/login',
    name: 'Authorisation',
    component: () => import('../views/Authorisation.vue'),
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'Authorisation' && !localStorage.getItem('hash')) next({ name: 'Authorisation' })
  else next()
})

// const originalPush = VueRouter.prototype.push;

// VueRouter.prototype.push = function push(location, onComplete, onAbort) {
//     const result = originalPush.call(
//         this,
//         location,
//         onComplete,
//         onAbort
//     );
//     if (result) {
//         return result.catch(err => {
//             if (err.name !== 'NavigationDuplicated') {
//                 throw err;
//             }
//         });
//     }
//     return result;
// };

// const originalReplace = VueRouter.prototype.replace;
// VueRouter.prototype.replace = function replace(location, onComplete, onAbort) {
//     const result = originalReplace.call(
//         this,
//         location,
//         onComplete,
//         onAbort
//     );
//     if (result) {
//         return result.catch(err => {
//             if (err.name !== 'NavigationDuplicated') {
//                 throw err;
//             }
//         });
//     }
//     return result;
// };
export default router
